module.exports = __webpack_public_path__ + "img/syachiku.84b48c91.png";